module.exports = __webpack_public_path__ + "media/bootstrap-icons/dice-4-fill-e9216493.svg";